import { isAbsoluteUrl } from '@/features/login/utils/get-correct-path-after-login';

export const addAuthTokenParams = (
  urlString: string,
  token: string,
): string => {
  //We need to add fallback for absolute path, because newUrl requires absolute url.
  // We won't use the localhost, if the url is not absolute. It's just for the new URL object to be created.
  const url = new URL(
    isAbsoluteUrl(urlString) ? urlString : `https://localhost:3000${urlString}`,
  );

  // Reset search params and set authToken first
  const currentParams = url.searchParams.toString();
  url.search = '';
  url.searchParams.set('authToken', token);

  // Add back all original params
  new URLSearchParams(currentParams).forEach((value, key) => {
    url.searchParams.append(key, value);
  });

  return isAbsoluteUrl(urlString) ? url.toString() : url.pathname + url.search;
};
